import { memo } from 'react';
import { ProductItemState } from '../../hooks/use-product-item-data';
import deepEqual from 'deep-equal';
import { Typography } from '../../../../../components/typography/typography';

export interface ProductItemExtraProps extends Pick<ProductItemState, 'isEditing' | 'delivery'> {}

// This component is used to display the extra information for a product item
export const ProductItemExtra = memo(
  ({ isEditing, delivery }: ProductItemExtraProps) => {
    // Return null if not editing or no delivery description
    if (!isEditing || !delivery?.description) return null;

    return (
      <div className="p-2">
        <Typography type="text-sm" weight="regular" className="text-quipli-black-700" dataCy="delivery-description">
          Delivery: {delivery.description.text}
        </Typography>
      </div>
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.isEditing === nextProps.isEditing &&
      deepEqual(prevProps.delivery.description, nextProps.delivery.description)
      // Add other props here if needed when adding extra information
    );
  },
);
